import React, { useEffect, useRef, useState } from "react";
import { useGoogleMapsScript } from "../../hook/useGoogleMapsScript"

export default function GmbAutocomplete({ value, onChange, onSelect }) {
  const { loaded, error } = useGoogleMapsScript();
  const serviceRef = useRef(null);
  const [input, setInput] = useState(value || "");
  const [predictions, setPredictions] = useState([]);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (!loaded || !window.google) return;
    if (!serviceRef.current) {
      serviceRef.current =
        new window.google.maps.places.AutocompleteService();
    }
  }, [loaded]);

  useEffect(() => {
    if (!input || !serviceRef.current || !loaded) {
      setPredictions([]);
      return;
    }

    const svc = serviceRef.current;
    let active = true;

    const request = {
      input,
      types: ["establishment"],
    };

    svc.getPlacePredictions(request, (results, status) => {
      if (!active) return;
      if (
        status !== window.google.maps.places.PlacesServiceStatus.OK ||
        !results
      ) {
        setPredictions([]);
        return;
      }
      setPredictions(results);
    });

    return () => {
      active = false;
    };
  }, [input, loaded]);

  const handleSelectPrediction = (prediction) => {
    setInput(prediction.description);
    setPredictions([]);
    setIsFocused(false);

    const dummyMapDiv = document.createElement("div");
    const placesService = new window.google.maps.places.PlacesService(
      dummyMapDiv
    );

    placesService.getDetails(
      {
        placeId: prediction.place_id,
        fields: ["url", "website", "name", "formatted_address"],
      },
      (place, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK && place) {
          const gmbUrl = place.url;
          const website = place.website || null;

          onSelect?.({
            name: place.name,
            address: place.formatted_address,
            url: gmbUrl,
            website,
            placeId: prediction.place_id,
          });

          onChange?.(gmbUrl);
        } else {
          const url = `https://www.google.com/maps/place/?q=place_id:${prediction.place_id}`;
          onSelect?.({
            name: prediction.description,
            url,
            website: null,
            placeId: prediction.place_id,
          });
          onChange?.(url);
        }
      }
    );
  };
  useEffect(() => {
    setInput(value || "");
  }, [value]);

  if (error) {
    return (
      <div>
        <input
          type="text"
          value={input}
          onChange={(e) => {
            setInput(e.target.value);
            setIsFocused(true);   // ← IMPORTANT FIX

            onChange?.(e.target.value);
          }}
          placeholder="Business profile link"
        />
        <p style={{ color: "red", fontSize: "12px" }}>
          Google Maps load nahi ho paaya: {error}
        </p>
      </div>
    );
  }

  return (
    <div style={{ position: "relative", width: "" }}>
      <input
        type="text"
        value={input}
        onFocus={() => setIsFocused(true)}
        onBlur={(e) => {
          if (!e.relatedTarget?.classList.contains("gmb-option")) {
            setTimeout(() => setIsFocused(false), 150);
          }
        }}

        onChange={(e) => {
          setInput(e.target.value);
          setIsFocused(true);    

          onChange?.(e.target.value);
        }}
        placeholder="Search your business on Google"
        className="gmb-input"
        autoComplete="off"
      />

      {isFocused && predictions.length > 0 && (
        <ul className="gmb-dropdown">
          {predictions.map((p) => (
            <li
              key={p.place_id}
              className="gmb-option"
              tabIndex={0}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => handleSelectPrediction(p)}
            >

              <div className="gmb-main-text">
                {p.structured_formatting?.main_text || p.description}
              </div>
              {p.structured_formatting?.secondary_text && (
                <div className="gmb-secondary-text">
                  {p.structured_formatting.secondary_text}
                </div>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
